<template>
  <div class="activityPositiveReport">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <reportTypeTable :wayString="wayString" :placehold="placehold" :Title="Title"></reportTypeTable>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import reportTypeTable from "@/components/report/reportType4";
import storeanalysisreport from "./analysisreport.js";
export default {
  name: "analysisreport-activityPositiveReport",
  data() {
    return {
      openMenu: ["8"],
      wayString: "activityPositiveReport", //传递到子组件的方法名称
      Title: '活动业绩统计报表',
      placehold: "" //传递到子组件的placehold
    };
  },
  components: {
    PageNav,
    reportTypeTable
  },
  created() {
    
    this.slider = this.$store.state.Slider;
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("analysisreport.less");
.activityPositiveReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
